import React from "react";
import BioMedicalWasteAnnualReportFormPage from "../components/bio-medical-waste/BioMedicalWasteAnnualReportFormPage";

const BioMedicalWasteAnnualReportEdit = () => (
  <BioMedicalWasteAnnualReportFormPage mode="edit" />
);

export default BioMedicalWasteAnnualReportEdit;
